import { Box } from "@mui/material";
import React, { useRef } from "react";
import Header from "../Header/Header";
import Youtubevideo from "../Youtubevideo/Youtubevideo";
import Brand from "../Brand/Brand";
import Aiviewdetails from "../Aiviewdetails/Aiview";
import FounderInfo from "../FounderInfo/FounderInfo";
import WelcomeAndAi from "../WelcomeAndAi/WelcomeAndAi";
import Ourpartners from "../Ourpartners/Ourpartners";
import SubHeader from "../../customComponents/SubHeader";
import { translation } from "../../assets/translation";
import { language } from "../../assets/function";
import { Colors } from "../../assets/colors";



function Home() {
  const staticText = translation[language];
  const HeaderRef = useRef(null);
  const YoutubevideoRef = useRef(null);
  const BrandRef = useRef(null);
  const Aiviewref = useRef(null);
  return (
    <Box>
      <Box ref={HeaderRef}>
        <Header />
      </Box>
      <Box ref={YoutubevideoRef}>
        <Youtubevideo />
      </Box>
      <Box>
        <SubHeader heading={staticText.ourClients}
         headerStyle={{backgroundColor:Colors.themeColor,paddingTop:{xs:0,sm:0,md:0,lg:0,xl:10}}} />
      </Box>
      <Box ref={BrandRef}>
        <Brand />
      </Box>
      <Box>
        <SubHeader heading={staticText.ourPartners}  headerStyle={{paddingBottom:{xs:0,sm:0,md:0,lg:0,xl:5}}} />
      </Box>
      <Box>
      <Ourpartners/>
      </Box>
      <Box ref={Aiviewref}>
        <Aiviewdetails />
      </Box>
      <Box>
        <FounderInfo />
      </Box>
      <Box>
        <WelcomeAndAi />
      </Box>
    </Box>
  );
}

export default Home;
